export const selectText = (element: HTMLElement) => {
    let range;
    const doc = document as any;
    if (doc.body.createTextRange) {
        range = (document.body as any).createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        if(selection) {
            range = document.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}

export const flattenObject = (obj: any) => {
    const toReturn: any = {};

    for (let i in obj) {
        if (!obj.hasOwnProperty(i)) continue;

        if ((typeof obj[i] === 'object')) {
            const flatObject = flattenObject(obj[i]);
            for (let x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) continue;

                toReturn[`${i}.${x}`] = flatObject[x];
            }
        } else {
            toReturn[i] = obj[i];
        }
    }

    return toReturn;
};